import { render, staticRenderFns } from "./TagsTemplate.vue?vue&type=template&id=63ac0b1a&scoped=true"
import script from "./TagsTemplate.vue?vue&type=script&lang=js"
export * from "./TagsTemplate.vue?vue&type=script&lang=js"
import style0 from "./TagsTemplate.vue?vue&type=style&index=0&id=63ac0b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac0b1a",
  null
  
)

export default component.exports